<template>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
        <FormItem label="原始账号">
          <span style="float:left;"> {{sta.userId}} </span>
        </FormItem>
        <FormItem label="手机号码" prop="tel" style="text-align: left;">
            <!-- <Input v-model="formCustom.tel" placeholder="请输入11位手机号码" @on-change="showtips=false"></Input> -->
             {{sta.mobileNum.replace(sta.mobileNum.substring(3,7),'****')}}
        </FormItem>
        <FormItem label="短信验证" prop="sms">
            <Row>
                <Col span="15"> <Input v-model="formCustom.sms" @on-change="showtips=false" placeholder="请输入验证码..." /></Col>
                <Col span="9"><Button type="primary" @click="getUserState" :disabled="!this.canClick">{{content}}</Button></Col>
            </Row>
        </FormItem>
        <FormItem>
            <!--  <Alert type="warning" show-icon :style="{display: showtips?'block':'none'}">
        <span slot="desc">{{this.errmsg}}</span>
      </Alert> -->
        </FormItem>
    </Form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'wxEditAccount-sms',
    data() {
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号码'));
                this.errorDesc = '请输入手机号码'
            } else {
                if (this.checkPhone(value)) {
                    callback()
                } else {
                    callback(new Error('手机号码输入有误,请重新输入.'));
                    this.errorDesc = '手机号码输入有误,请重新输入.'
                }
            }
        };
        const validateSms = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入短信验证码'));
                this.errorDesc = '请输入短信验证码'
            } else {
                callback();
            }
        };
        return {
            formCustom: {
                tel: '',
                sms: '',
                smstypecode: 0,
                //type:0,//1=微信合并账号密码，2=微信创建账号密码
                reqidentity:'',
            },
            ruleCustom: {
                tel: [
                    { required: true, validator: validateTel, trigger: 'blur' }
                ],
                sms: [
                    { required: true, validator: validateSms, trigger: 'blur' }
                ],
            },
            showtips: false,
            errmsg: '您所提交的信息有误,请重新输入',
            content: '发送验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            isSend: false, //防止重复提交请求
            isError: false, //验证短信验证码是是否包含异常信息
            errorDesc: '',
            //confirmDesc:'',
        }
    },
    computed:{
        ...mapGetters(['sta'])
    },
    methods: {
        cleanSmsCode() {
            this.formCustom.sms = ''
        },
        // checkSmsCode(desc) {
        //     this.$Modal.confirm({
        //         title: '提示',
        //         content: '<p>' + desc + '</p>',
        //         cancelText: "否",
        //         okText: "是",
        //         onOk: () => {
        //             //this.weiXinRegAndLogin(po)
        //             this.countDown()
        //         },
        //         onCancel: () => {
        //             return
        //         }
        //     });
        // },
        handleSubmit(name) {
            console.log(name)
            this.$refs[name].validate((valid) => {
                if (valid && !this.isError) {
                    this.showtips = false;
                    if (this.formCustom.smstypecode === 0) {
                        this.$Message.warning('您还未成功发送验证码')
                        return
                    }
                    this.$emit('wxSmsCodeCheckOk', this.formCustom);

                } else {
                    this.$Message.error(this.errorDesc);
                    this.showtips = true;
                }
            })
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
        checkPhone(phoneNum) {
            var phone = phoneNum;
            if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
                //alert("手机号码有误，请重填");  
                return false;
            } else {
                return true;
            }
        },

        //原逻辑后端判断了手机号码，没有做任何修改？？？ 2021-10-21
        getUserState1() {
            this.formCustom.tel = this.sta.mobileNum
            let po = {
                mobilenum: this.formCustom.tel,
                // smscode:args.smscode,
                // reqidentity:args.reqidentity,
            }
            //
            constJ.reqWXEditUserId(po).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                         this.countDown()
                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })


        },


        //修改账号，发送短信
        getUserState() {
            this.formCustom.tel = this.sta.mobileNum
            this.countDown()
        },
        
        // getUserState1() {
        //     let po = {
        //         mobilenum: this.formCustom.tel,
        //         // smscode:args.smscode,
        //         // reqidentity:args.reqidentity,
        //     }
        //     constJ.reqWXEditUserId(po).then(res => {
        //         console.log(res)
        //         if (res.rtncode === 1) {
        //             if (res.rltcode === 1) {
        //                 // 也就是说一个人可以通过手机注册账号购买账号等级，也可以通过微信扫描运营商二维码购买账号等级，同时拥有两个账号等级且各自独立。 若此时，用户通过微信直接登录的方式进入云擎后，在主页系统生成的账号下拉菜单中，点击“修改账号”，当输入手机号码获取验证码时，系统提示“您输入的电话号码已绑定其他账号”，只有当用这个电话号码注册的账号等级超过冻结期而注销账号解除手机绑定了才能用来“修改账号”
        //                 //您输入的电话号码已绑定其他账号
        //                 if (res.data) {

        //                     let r = res.data.mobileisreg
        //                     if (r) {
        //                         //发送验证码并绑定
        //                         //弹出询问是否合并
        //                         let desc="系统检测到手机号码:["+this.formCustom.tel+"]已存在账号，是否合并此账号?"
        //                         this.formCustom.type=1
        //                         this.checkSmsCode(desc)
        //                         //this.$emit('wxMergeUserid',this.formCustom)
        //                     } else {
        //                         this.formCustom.type=2
        //                         this.countDown()
        //                         ///let desc="您输入的电话号码已绑定其他账号"
        //                         //this.$Message.warning(desc)
        //                     }
        //                 } else {
        //                     this.$Message.warning('修改账号,数据异常')
        //                 }
        //             } else {
        //                 this.$Message.warning(res.rltdesc)
        //             }
        //         } else {
        //             this.$Message.warning(res.rtndesc)
        //         }
        //     })


        // },
        countDown() {
            if (this.isSend) {
                //this.$Message.warning('验证码已发送')
                return
            } else {
                this.isSend = true
                if (!this.checkPhone(this.formCustom.tel)) {
                    this.errmsg = "电话号码有误,请修改";
                    this.showtips = true;
                    this.isSend = false
                    return
                }



                //console.log(this.$Tools.getSMSFrom())
                this.formCustom.smstypecode = this.$Tools.getSMSFrom().SMS_CODE_TYPE_EDIT_ACCOUNT
                regJ.reqSmsCode(this.formCustom.tel, this.$Tools.getSMSFrom().SMS_CODE_TYPE_EDIT_ACCOUNT).then(res => {
                    this.isSend = false
                    console.log(res)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.formCustom.reqidentity=res.reqidentity
                            this.isError = false
                            this.$Message.info('验证码已发送')
                        } else {
                            //处理异常情况，并弹出确认提示
                            this.isError = true
                            this.$Message.error(res.rltdesc);
                            this.errorDesc = res.rltdesc
                            return
                        }
                    } else {
                        this.$Message.error(res.rtndesc);
                        return
                    }

                    if (!this.canClick) return
                    this.canClick = false
                    this.content = this.totalTime + 's后重新发送'
                    let clock = window.setInterval(() => {
                        this.totalTime--
                        this.content = this.totalTime + 's后重新发送'
                        if (this.totalTime < 0) {
                            window.clearInterval(clock)
                            this.content = '发送验证码'
                            this.totalTime = 60
                            this.canClick = true //这里重新开启
                        }
                    }, 1000)
                })
            }

        },
    },

}
</script>
<style>
</style>